import { DropzoneField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { Button, FieldProps, FormLabel, Stack } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { UnicodeEntity } from '@mews/enums';
import { SUPPORTED_FILE_EXTENSIONS } from '../constants';
import { ViewFileCard } from './ViewFileCard';

export interface ChangeFileFieldProps {
    fieldProps: FieldProps;
    fileName: string;
    fileId: string;
    isNewFile: boolean;
    setIsNewFile: (isNewFile: boolean) => void;
    openFile: ({ id }: { id: string }) => void;
    isPending: boolean;
}

export const ChangeFileField = ({
    fieldProps,
    fileName,
    fileId,
    isNewFile,
    setIsNewFile,
    openFile,
    isPending,
}: ChangeFileFieldProps) => {
    return (
        <Stack vertical spacing="100">
            {isNewFile ? (
                <DropzoneField {...fieldProps} accept={SUPPORTED_FILE_EXTENSIONS} />
            ) : (
                <Stack spacing="25" vertical>
                    <FormLabel>
                        {lt('File')}
                        {UnicodeEntity.Space}
                        {UnicodeEntity.Asterisk}
                    </FormLabel>
                    <Stack vertical spacing="100">
                        <ViewFileCard fileName={fileName} fileId={fileId} openFile={openFile} isPending={isPending} />
                        <Stack itemAlignment="start" vertical>
                            <Button icon={IconName.FolderClosed} type="button" onClick={() => setIsNewFile(true)}>
                                {lt('ContractReplaceFileLabel')}
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
